import React from "react";
import { FaFacebookSquare } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { BiLogoGithub } from "react-icons/bi";
import { SlUserFollowing } from "react-icons/sl";
import { HiOutlineBriefcase } from "react-icons/hi";
import { PiGraduationCap } from "react-icons/pi";
import { LuLayers } from "react-icons/lu";
import { BiMessage } from "react-icons/bi";
import { GiSkills } from "react-icons/gi";
import {BsFillTelephoneOutboundFill} from 'react-icons/bs'
import {RiMailCheckFill} from 'react-icons/ri'

const Footer = () => {
  return (
    <>
    <footer className="footer">
      <div className="footer1">
        <h1>Emily Han</h1>
        <p>Product Manager and technical builder passionate about AI/ML and product execution.</p>
      </div>
      <div className="footer2">
        <h4>SECTIONS</h4>
        <a href="#about"> <SlUserFollowing/> About</a>
        <a href="#projects"> <HiOutlineBriefcase/> Projects</a>
        <a href="#skills"> <GiSkills/> Skills</a>
        <a href="#blog"> <BiMessage/> Blogs</a>
      </div>
      <div className="footer3">
        <h4>FOLLOW ME</h4>
        <div className="footerIcons">
          <FaLinkedin className="footerIcon" />
          <BiLogoGithub className="footerIcon" />
        </div>
      </div>
      <div className="footer4">
        <h4>CONTACT ME</h4>
        <p> <RiMailCheckFill/> emilyhan0212@gmail.com</p>
      </div>
    </footer>
    <hr style={{ marginTop: "2rem" }} />

    <div style={{
      textAlign: "center",
      padding: "1rem 0",
      fontSize: "1.2rem",
      color: "var(--black-light-extra)"
    }}>
      © {new Date().getFullYear()} <strong>Emily Han</strong>. All rights reserved.
    </div>
  </>
  );
};

export default Footer;
